import { Grid } from '@mui/material';

import {
  useLoaders,
  useTableFilter,
  useTableServerSideFiltering,
} from '@/shared';
import { useFetchTransacciones } from '@/shared/actions/erp';
import { GeneralTable } from '@/shared/components/ui';
import { Contrato, Transaccion } from '@/shared/interfaces';
import { useColumnsTransaccionesCliente } from '../../../hooks';

export type ClienteFibraTransaccionTabProps = {
  contract: Contrato;
};

const ClienteFibraTransaccionTab: React.FC<ClienteFibraTransaccionTabProps> = ({
  contract,
}) => {
  ///* table ---------------------------
  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pagination, searchTerm, setPagination } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  ///* fetch data -------------------------
  const {
    data: transaccionesPagingRes,
    isLoading: isLoadingTransacciones,
    isRefetching: isRefetchingTransacciones,
  } = useFetchTransacciones({
    enabled: !!contract?.id_contrato,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      ...filterObject,
      cliente: contract?.cliente,
      concepto: searchTerm,
    },
  });

  useLoaders(isLoadingTransacciones || isRefetchingTransacciones);

  ///* columns -------------------------
  const { columnsTransaccion } = useColumnsTransaccionesCliente({
    contract,
  });

  return (
    <Grid item container xs={12}>
      {/* ================= table ================= */}
      <Grid item xs={12}>
        <GeneralTable<Transaccion>
          columns={columnsTransaccion}
          data={transaccionesPagingRes?.data?.data || []}
          //
          isLoading={isLoadingTransacciones}
          isRefetching={isRefetchingTransacciones}
          // // filters - llega al back
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          // // search
          enableGlobalFilter={false}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={transaccionesPagingRes?.data?.count}
          // // actions
          // custom actions - custom colum
          enableColumnActions={false}
          enableEditing={false}
          canDelete={false}
        />
      </Grid>
    </Grid>
  );
};

export default ClienteFibraTransaccionTab;
